import { IconProps } from "./../Icon/icon.types";
import { ImageProps } from "./../Image/image.types";
import DefaultProps from "../../commonTypes/defaultprops.types";
import Handler from "commonTypes/handler.types";

export enum ContentCardOrientations {
  PORTRAIT = "portrait",
  LANDSCAPE = "landscape"
}

export interface ContentCardVideoProps {
  duration?: string;
  callOutTextProps?: ContentCardCallOutTextProps;
  hideIcon?: boolean;
  iconProps: IconProps;
}

export interface ContentCardCallOutTextProps {
  text: string;
  color?: string;
}

export interface ContentCardProps extends DefaultProps {
  imageProps: ImageProps;
  headline: string;
  orientation?: ContentCardOrientations;
  publishDate: string;
  handlers?: Handler;
  videoProps?: ContentCardVideoProps;
  url?: string;
  target?: string;
  rel?: string;
  isActive?: boolean;
  isActiveText?: string;
  optionsComponent?: React.ReactNode;
}

export interface ContentCardSkeletonProps {
  headlineCount: number;
  headlineWidth: string | number;
  headlineHeight: string | number;
  headlineMargin?: number;
  dateWidth: string | number;
  dateHeight: string | number;
  dateMargin: number;
  imageBorderRadius?: string | number;
  imageWidth: string | number;
  imageHeight: string | number;
}


export interface ContentCardImageWrapperProps extends DefaultProps {
  isActive?: boolean;
  isActiveText?: string;
  imageProps: ImageProps;
  orientation: ContentCardOrientations;
  fixAspect?: boolean;
}

export type CardRef = React.Ref<HTMLElement>;
